/**
 * The Wealthoak logo, shown exactly as supplied (public/brand/wealthoak-logo.webp).
 * The same file is the favicon in index.html.
 *
 * Decorative only: every place it appears already carries the name as text
 * or an aria-label, so the alt text is empty.
 */
export default function BrandMark({ size = 32 }: { size?: number }) {
  return (
    <img
      className="brand-mark"
      src="/brand/wealthoak-logo.webp"
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
    />
  );
}
